<!--
Este componente recibe como parametros las varibles de control de visibilidad de
las flechas de avanzar y retroceder (atrasVisible y adelanteVisible). También recibe los diálogoa reproducir.
El componente automáticamente actualiza el texto (currentText) y devuelve el nuevo valor
a través de la función :update:currentText para notificar al padre.
recibe instructor: Number (tres instructores)
NOTA: Se asume que los diálogos siempre van a empezar en el diálogo 0
-->
<template>
    <v-layout align-center justify-center row>
        <v-flex class="animated fadeInDown">
            <v-layout row wrap align-center justify-center class="cont-dialogo">
                <div class="personaje text-xs-center md2 sm2 xs12" >
                    <img :src="require('@/assets/imagenes_compartidas/personaje-'+personaje+'.png')">
                </div>
                <v-flex class="dialogos" :class="{'dialogos-center':diagCenter}" xs12 md10 sm10 >
                    <div @click="adelante" class="flecha-adelante diagnav hvr animated pulse animainfinite"
                            v-show="adelanteVisible && currentText < dialogos.length - 1">
                           <v-icon class="icon" >keyboard_arrow_right</v-icon>
                    </div>
                    <div @click="atras" class="flecha-atras diagnav hvr animated bounceIn"
                            v-show="atrasVisible && currentText>0">
                        <v-icon class="icon" >keyboard_arrow_left</v-icon>
                    </div>
                    <v-layout align-center justify-center class="ml-2" row>
                        <v-flex>
                            <p :id="'diag-'+idx" :key="idx" v-for="(dialogo, idx) in dialogos"
                               v-show="currentText == idx"><span v-html="dialogo"></span></p>
                            <slot></slot>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        props: {
            atrasVisible: {
                type: Boolean,
                default: true
            },
            adelanteVisible: {
                type: Boolean,
                default: true
            },
            dialogos: {
                type: Array,
                required: true
            },
            personaje: {
                type: String,
                default: "0"
            },
            diagCenter:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                imgPersonaje: '',
                currentText: 0,
                arrPersonaje: [""],
                background: ''
            }
        },
        created() {
            try {
                for (var i = 0; i < 3; i++) {
                    this.getPng('', data => {
                        this.arrPersonaje.push(data);
                    });
                }
                this.cambiarPersonaje(this.personaje);
            } catch (error) {
                console.log('Se registra error con funcion: getPng()')
            }
            
        },
        methods: {
            atras() {
                this.currentText--;
                this.$emit('update:currentText', this.currentText);
            },
            adelante() {
                this.currentText++;
                this.$emit('update:currentText', this.currentText);
            },
            saltarAlDialogo(numeroDialogo) {
                this.currentText = numeroDialogo;
                this.$emit('update:currentText', this.currentText);
            },
            cambiarPersonaje(numPersonaje) {
                this.imgPersonaje = this.arrPersonaje[numPersonaje];
            }
        },
        watch: {
            personaje: function (newVal, oldVal) { // watch it
                this.cambiarPersonaje(newVal);
            }
        }

    }
</script>

<style lang="scss" scoped>
@import '../sass/globals';
.cont-dialogo{
    border-bottom: 2px;
    border-top: 2px;
    border-left: 0px;
    border-right: 0px;
    border-style: solid;
    border-color: $color-secondary;
    margin-top: 30px;
}
.personaje {
    margin: 0 auto;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-right: -10px;
    width: 60px;
    height: 60px;
    img {
        width: 60px;
    }
    @media screen and (max-width: 900px) {
        width: 50px;
        height: 50px;
        margin:0 auto;
        margin-top: -30px;
        img{
            width: 50px;
        }       
    }
}

.dialogos {
    position: relative;
    padding: 10px 10px;
    margin: 0 auto;
    border-radius: 4px;
    text-align: left;
    p {
        margin: 0;
        font-size: 1rem;
    }
    margin-bottom: 8px;
    @media screen and (max-width: 900px) {
        padding-left: 10px; 
    }
}
.diagnav {
    width:30px;
    height: 100%;
    cursor: pointer;
    right: 2px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon{
        font-size: 40px;
    }
    &:hover{
        .icon{
            color:$color-secondary;

        }
    }
}
.flecha-atras {
    left: 35px;
    top: 0;
}
.flecha-adelante {
    right: 0;
    top: 0;
}
p {
    font-family:FontBase-Italic;
    line-height: 1.3em;
}
.dialogos-center{
    text-align: center;
}
.animainfinite{
    animation-iteration-count: infinite;
    animation-duration: 0.7s;
}
.icon{
    color: $color-text;
    
}
</style>
